// extracted by mini-css-extract-plugin
module.exports = {"range-slider":"range-slider_range-slider__UZRiX","range-slider__arrow":"range-slider_range-slider__arrow__14Ypa"};